class Controller {
  constructor($stateParams, FileDownload, Events) {
    "ngInject";

    this.token = $stateParams.token;
    this.resource = $stateParams.resource;
    this.FileDownload = FileDownload;
    this.Events = Events;

    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.pageMessage = "Please wait while redirecting to the file link...";

    this.FileDownload.get(this.resource, this.token).$promise.then(
      (response) => {
        this.pageMessage = "You may now close the page.";
        const { url } = response;
        window.location = url;
      },
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/fileDownload/fileDownload.controller.js